import { DEFAULT_KEY } from '../constants';
import { generate32ByteKey, generate12ByteNonce, stringToUint8Array } from '../utils/stringUtils';
import { Chacha20 } from 'ts-chacha20';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function encrypt(message, key, nonce) {
  key = key.length > 0 ? key : DEFAULT_KEY;
  key = generate32ByteKey(key);
  nonce = generate12ByteNonce(nonce ?? "");
  const keyBuffer = stringToUint8Array(key);
  const nonceBuffer = stringToUint8Array(nonce);
  const chacha20 = new Chacha20(keyBuffer, nonceBuffer);
  const messageBuffer = stringToUint8Array(message);
  const encrypted = chacha20.encrypt(messageBuffer);
  return Buffer.from(encrypted).toString("hex");
}
__name(encrypt, "encrypt");

export { encrypt };
